export default {
  state: {
    acornCodes: null,
    acornCodesErr: null,
  },
  mutations: {
    setAcornCodes(state, acornCodes) {
      state.acornCodes = Object.freeze(acornCodes)
    },
    setAcornCodesErr(state, err) {
      state.acornCodesErr = Object.freeze(err)
    }
  },
  actions: {
    async getAcornCodes(context) {
      await context.rootState.inst.get(
        `/api/dailyreports/socioeconomic_codes/acorn_code/`,
        { backgroundRequest: true }
      ).then((response) => {
        context.commit('setAcornCodes', response.data);
        context.commit('setAcornCodesErr', null)
      }).catch(err => {
        context.commit('setAcornCodesErr', err);
      });
    },
  }
}